import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Dialog, DialogContent, DialogActions, Button, TextField, CircularProgress } from "@material-ui/core";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { FormDialogHeader, useFormDialogStyles } from "../FormDialog";

// Adicionar ou editar um contato de uma lista de campanha
const ContactListItemModal = ({ open, onClose, contactId, onSave, contactListId: listIdProp }) => {
  const classes = useFormDialogStyles();
  const params = useParams();
  const contactListId = listIdProp || params.contactListId;

  const [form, setForm] = useState({ name: "", number: "", email: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setForm({ name: "", number: "", email: "" });
    if (!contactId) return;
    api
      .get(`/contact-list-items/${contactId}`)
      .then(({ data }) => setForm({ name: data.name || "", number: data.number || "", email: data.email || "" }))
      .catch(toastError);
  }, [open, contactId]);

  const digits = form.number.replace(/\D/g, "");
  const nameOk = form.name.trim().length >= 3;
  const numberOk = digits.length >= 10;

  const save = async (e) => {
    if (e) e.preventDefault();
    if (!nameOk || !numberOk || saving) return;
    setSaving(true);
    try {
      const payload = { name: form.name.trim(), number: digits, email: form.email.trim(), contactListId };
      const { data } = contactId
        ? await api.put(`/contact-list-items/${contactId}`, payload)
        : await api.post("/contact-list-items", payload);
      toast.success(
        data.isWhatsappValid === false
          ? "Contato salvo, mas o número não tem WhatsApp (ou a conexão está desligada)"
          : "Contato salvo"
      );
      if (onSave) onSave(data);
      onClose();
    } catch (err) {
      toastError(err);
    }
    setSaving(false);
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth classes={{ paper: classes.paper }}>
      <form onSubmit={save}>
        <FormDialogHeader
          title={contactId ? "Editar contato" : "Adicionar contato"}
          subtitle="O número é verificado no WhatsApp ao salvar."
          onClose={onClose}
          disabled={saving}
        />
        <DialogContent dividers className={classes.content} style={{ gap: 16 }}>
          <TextField
            label="Nome"
            variant="outlined"
            fullWidth
            autoFocus
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            error={form.name.length > 0 && !nameOk}
            helperText={form.name.length > 0 && !nameOk ? "Use pelo menos 3 letras" : " "}
          />
          <TextField
            label="Número com DDD"
            variant="outlined"
            fullWidth
            value={form.number}
            onChange={(e) => setForm({ ...form, number: e.target.value })}
            error={form.number.length > 0 && !numberOk}
            helperText={form.number.length > 0 && !numberOk ? "Número incompleto" : "Ex.: 5511988887777 (com o 55 do Brasil)"}
            inputProps={{ inputMode: "tel" }}
          />
          <TextField
            label="E-mail (opcional)"
            variant="outlined"
            fullWidth
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button onClick={onClose} disabled={saving} className={`${classes.actionButton} ${classes.cancelButton}`}>
            Cancelar
          </Button>
          <div className={classes.progressWrapper}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disableElevation
              disabled={!nameOk || !numberOk || saving}
              className={classes.actionButton}
            >
              Salvar
            </Button>
            {saving && <CircularProgress size={24} className={classes.buttonProgress} />}
          </div>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ContactListItemModal;
